module.exports = __webpack_public_path__ + "static/media/bio-preview.4ad40dba.svg";